import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LayoutNavItem, LayoutNavItemDivider } from '../../layout.interface';

/**
 * @ignore
 */
@Component({
  selector: 'uex-layout-nav-item',
  templateUrl: './item.component.html',
  host: {
    'class': 'uex-layout-nav-item list-group-item list-group-item-full-action',
    '[class.collapsable]': 'hasSubmenu()',
    '[class.collapsed]': 'hasSubmenu() && !item.opened'
  }
})
export class LayoutNavItemComponent implements OnInit, OnDestroy {
  @Input('data') private set _setItem(item: LayoutNavItem | LayoutNavItemDivider) {
    this.item = item as LayoutNavItem;
    if (!_.isBoolean(item.divider)) { item.divider = false; }
  }
  @Input('submenu') submenu = false;

  constructor(
    private _router: Router
  ) { }

  private _route_subscription: Subscription;
  public item: LayoutNavItem;

  public ngOnInit() {
    this._updateItemOpened();

    this._route_subscription = this._router.events
    .pipe(filter((e) => e.constructor == NavigationEnd))
    .subscribe(() => this._updateItemOpened());

  }

  public ngOnDestroy() {
    if (this._route_subscription) { this._route_subscription.unsubscribe(); }
  }

  public hasSubmenu(): boolean {
    const item = (<LayoutNavItem>this.item);
    return item && item.items && item.items.length > 0;
  }

  public onClick(event?: MouseEvent) {
    if (event) { event.preventDefault(); }

    const item = (<LayoutNavItem>this.item);
    if (!item) { return; }

    if (item.items) {
      item.opened = !item.opened;
    } else if (_.isFunction(item.action)) {
      item.action();
    } else if (item.url) {
      this._router.navigate([item.url]);
    }
  }

  public isActive(): boolean {
    const item = (<LayoutNavItem>this.item);
    const item_url = item.url;
    const route_url = this._router.routerState.snapshot.url.replace(/\#.*/g, '');
    return item_url == route_url;
  }

  private _isActiveParent(): boolean {
    const item = (<LayoutNavItem>this.item);
    return this.hasSubmenu() && item.url ? this._router.isActive(item.url, false) : false;
  }

  private _updateItemOpened() {
    if (this._isActiveParent()) { (<LayoutNavItem>this.item).opened = true; }
  }
}
